import {
    INTEGRATION_GET_EXPOSURE_TYPE_BEGIN,
    INTEGRATION_GET_EXPOSURE_TYPE_SUCCESS,
    INTEGRATION_GET_EXPOSURE_TYPE_FAILURE
  } from '../constants'
  import { BFFAgent } from 'BFFAgent'
import { INTEGRATION_EXPOSURE_TYPE_NAME } from 'car-data-catalogo/Constants'
  
  export function getExposureTypes(accountId) {
    return async dispatch => {
      dispatch({
        type: INTEGRATION_GET_EXPOSURE_TYPE_BEGIN
      })
  
        try {
            const res = await BFFAgent.Integrations.getExposureTypes(accountId)
            /* Arreglo de tipo de exposiciones
              [
                {
                  available_listings: 60
                  listing_type_id: "silver"
                  remaining_listings: 27
                  used_listings: 33
                }
              ]
            */
                const orderIndex = {
                  silver: 0,
                  gold: 1,
                  gold_premium: 2,
                }
                const exposureTypesList = res.map(exposureType => {
                    const label = INTEGRATION_EXPOSURE_TYPE_NAME[exposureType.listing_type_id]
                    const remaining = `${exposureType.remaining_listings}/${exposureType.available_listings}`
                   return {
                    value: exposureType.listing_type_id,
                    label,
                    subTitle: `Publicaciones disponibles ${remaining}`,
                    isDisabled: exposureType.remaining_listings === 0,
                    inputLabel: `${label} (${remaining})`,
                    order: orderIndex[exposureType.listing_type_id] || 0
                }})

            dispatch({
                type: INTEGRATION_GET_EXPOSURE_TYPE_SUCCESS,
                data: exposureTypesList,
            })
        
        } catch {
            dispatch({
            type: INTEGRATION_GET_EXPOSURE_TYPE_FAILURE
            })
      }
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
        case INTEGRATION_GET_EXPOSURE_TYPE_BEGIN:
            return {
                ...state,
                isExposurePending: true,
            }

        case INTEGRATION_GET_EXPOSURE_TYPE_SUCCESS:
            return {
                ...state,
                isExposurePending: false,
                exposureTypesList: action.data,
            }
  
        case INTEGRATION_GET_EXPOSURE_TYPE_FAILURE:
            return {
                ...state,
                isExposurePending: false,
            }
  
      default:
        return state
    }
  }
  